module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.native) ? _c("dialog", {
    tag: "dialog",
    staticClass: "dialog",
    class: _vm.clazz,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], true) : _vm._e()]), _vm._v(" "), (!_vm.native && _vm.isShow) ? _c('div', {
    staticClass: "dialog",
    class: {
      poly: _vm.isModal
    }
  }, [(_vm.isModal) ? _c('div', {
    staticClass: "mask-layer"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-wrapper",
    class: _vm.clazz,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], true)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-14df9ea9!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./source/DialogPanel/DialogElement.vue
// module id = 156
// module chunks = 1 3 4